export default {
  inWarrantyTitle: {
    id: 'after_sales_care_folder_warranty_info_in_warranty',
    defaultMessage: 'In warranty',
  },
  outWarrantyTitle: {
    id: 'after_sales_care_folder_warranty_info_out_warranty',
    defaultMessage: 'Out of warranty',
  },
  sellerWarrantyTitle: {
    id: 'after_sale_care_folder_warranty_info_seller_warranty_title',
    defaultMessage: 'Seller warranty',
  },
  sellerWarrantyExtensionTitle: {
    id: 'after_sale_care_folder_warranty_info_seller_warranty_extension_title',
    defaultMessage: 'Seller warranty extension',
  },
  backmarketWarrantyTitle: {
    id: 'after_sale_care_folder_warranty_info_backmarket_warranty_title',
    defaultMessage: 'Backmarket warranty',
  },
  outOfWarrantyDescription: {
    id: 'after_sale_care_folder_warranty_info_out_warranty_description',
    defaultMessage: 'No warranty applied',
  },
  sellerWarrantyDescription: {
    id: 'sav_platform_merchant_warranty_new',
    defaultMessage: `Warranty {duration, plural,
      one {# month}
      other {# months}
    } free until {date, date}`,
  },
  sellerWarrantyExtensionDescription: {
    id: 'sav_platform_merchant_warranty_extension_new',
    defaultMessage: `Warranty extension {duration, plural,
      one {# month}
      other {# months}
    } until {date, date}`,
  },
  backmarketWarrantyDescription: {
    id: 'sav_platform_backmarket_warranty',
    defaultMessage: `Back Market warranty extension {duration, plural,
      one {# month}
      other {# months}
    } until {date, date}`,
  },
}
